import { createMuiTheme } from '@material-ui/core/styles'

const theme = createMuiTheme({
  palette: {
    primary: {
      main: '#1b5e20'
    },
    secondary: {
      main: '#e65100'
    }
  }
})

export default theme
